export enum CabinTargetingMode {
  ALL = 'all',
  OFF = 'off',
  TARGETED = 'targeted',
}
